import translate from '../../../../utils/translations';
import actions from './allowedActions';

const CANCEL_TYPES = {
    AUTO_CANCELLATION: 'auto cancel',
    CANCELLATION_REQUEST: 'cancel',
    DEFAULT: null,
    WITHDRAWAL: 'withdraw',
};
const WITHDRAWAL_CANCELLATION_TYPE = 'WITHDRAWAL';
const WITHDRAWAL_STATE = 'WITHDRAWN';

const getCancellationInfo = (allowedActions, translations) => {
    const {REQUEST_TO_CANCEL, REQUEST_TO_WITHDRAW, SELF_SERVICE_CANCEL} =
        actions;
    let label = '';
    let type = CANCEL_TYPES.DEFAULT;

    if (allowedActions.includes(SELF_SERVICE_CANCEL)) {
        label = translate(
            translations,
            'trav-dash/trav-home',
            'messages',
            'th.inbox.conversation.cancellation.refund.label'
        );
        type = CANCEL_TYPES.AUTO_CANCELLATION;
    } else if (allowedActions.includes(REQUEST_TO_CANCEL)) {
        label = translate(
            translations,
            'trav-dash/trav-home',
            'messages',
            'th.inbox.conversation.cancellation.request.label'
        );
        type = CANCEL_TYPES.CANCELLATION_REQUEST;
    } else if (allowedActions.includes(REQUEST_TO_WITHDRAW)) {
        label = translate(
            translations,
            'trav-dash/trav-home',
            'messages',
            'th.inbox.conversation.cancellation.withdrawal.label'
        );
        type = CANCEL_TYPES.WITHDRAWAL;
    }
    return {label, type};
};

export {getCancellationInfo, WITHDRAWAL_CANCELLATION_TYPE, WITHDRAWAL_STATE};
